import { PARTICIPANTS_CATEGORIES } from 'constants/participants'
import { GetParticipantsWithVisibleBirthdatesConfNumber } from './types/getParticipantsWithVisibleBirthdatesConfNumber.types'
import { getParticipantsNumberInCategory } from '.'

export const getParticipantsWithVisibleBirthdatesConfNumber: GetParticipantsWithVisibleBirthdatesConfNumber = (
  packageConf,
  participants
) => (
  PARTICIPANTS_CATEGORIES.reduce<number>((participantsNumber, category) => (
    ((participants[category] && packageConf[category]) &&
     (packageConf[category].visible && packageConf[category].askBirthdays))
      ? participantsNumber + getParticipantsNumberInCategory(participants, category)
      : participantsNumber
  ), 0)
)
